import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { billing } from "@/lib/api";

export function useBilling() {
  const [state, setState] = useState(null);
  const loc = useLocation();
  useEffect(() => { billing.me().then(setState).catch(() => setState(null)); }, [loc.pathname]);
  return state;
}

export default function TrialBanner({ state }) {
  if (!state || state.status === "active" || state.status === "complimentary") return null;
  const ended = state.status === "inactive";
  const driver = state.fleet_role === "driver";
  if (driver && !ended) return null;
  return <div data-testid="trial-banner" className={`${ended ? "bg-destructive text-white" : "bg-accent text-accent-foreground"}`}>
    <div className="max-w-7xl mx-auto px-4 lg:px-6 py-2 flex flex-wrap items-center justify-between gap-2 text-sm">
      <span className="font-bold" data-testid="trial-banner-text">
        {ended ? (driver ? "Your fleet's plan has ended. Records are read-only until the fleet owner chooses a plan." : "Your free trial has ended. Records are read-only until you choose a plan.")
               : `Free trial: ${state.days_left} day${state.days_left === 1 ? "" : "s"} left.`}
      </span>
      {!driver && <Link to="/app/billing" data-testid="trial-banner-cta" className={`font-bold uppercase tracking-wider text-xs px-3 py-1.5 ${ended ? "bg-white text-destructive" : "bg-primary text-white"}`}>
        Choose a plan
      </Link>}
    </div>
  </div>;
}
